const enum SettingsFieldTypes {
  SELECT = 'Select',
  TEXT = 'Text',
  JSON = 'JSON',
}

class SettingsField {
  static type: SettingsFieldTypes;
  slug: string
  type: string

  constructor(values: any, key: string) {
    if (Object.getPrototypeOf(this).constructor === SettingsField) {
      const TypeField = SettingsField.getFieldFromType(values.type)
      this.type = TypeField.type;
      return new TypeField(values, key)
    }

    Object.assign(this, values)
    this.slug = key
    this.type = Object.getPrototypeOf(this).constructor.type;
    return this
  }

  static getFieldFromType(type: SettingsFieldTypes) {
    switch (type) {
      case SettingsFieldTypes.SELECT:
        return SettingsFieldSelect
      case SettingsFieldTypes.JSON:
        return SettingsFieldJSON
      default:
        return SettingsFieldText
    }
  }

  encode(value: any) {
    return value
  }

  decode(value: any) {
    return value
  }
}

class SettingsFieldSelect extends SettingsField {
  static type = SettingsFieldTypes.SELECT
  options: [{ label: string, value: any }];

  encode(value: any) {
    if (this.options.find((o) => o.value === value)) {
      return value
    }

    const option = this.options.find((o) => o.label === value)
    return option?.value || null
  }

  decode(value: any) {
    const option = this.options.find((o) => o.value === value)
    return option?.label || null
  }
}

class SettingsFieldText extends SettingsField {
  static type = SettingsFieldTypes.TEXT
  encode(value: any) {
    return value?.toString() || ''
  }

  decode(value: any) {
    return value?.toString() || ''
  }
}

class SettingsFieldJSON extends SettingsField {
  static type = SettingsFieldTypes.JSON
  encode(value: any) {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return "{}"
    }
  }

  decode(value: any) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return {}
    }
  }
}

export { SettingsField, SettingsFieldSelect, SettingsFieldText, SettingsFieldJSON, SettingsFieldTypes };
export default SettingsField
